module.exports = __webpack_public_path__ + "img/6-4.2c9ba387.png";